import React, { useEffect, useRef, useState } from 'react'

// next components
import { useRouter } from 'next/router'

// third party components
import { useDispatch } from 'react-redux'

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// components
import FeaturedArtworkCard from 'components/Card/FeaturedArtworkCard'
import { HomePrevButton } from 'components/Button/HomePrevButton'
import { HomeNextButton } from 'components/Button/HomeNextButton'

// custom functions
import { useViewport } from 'utils'

// styles
import styles from './index.module.scss'

// call apis
import dashboardAPI from 'apis/dashboard'

const FeaturedArtworkSection = props => {
  const {} = props
  const viewport = useViewport()
  const router = useRouter()
  const dispatch = useDispatch()
  const [featuredArtworkList, setFeaturedArtworkList] = useState([])
  const [artist, setArtist] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const swiperRef = useRef(null)

  const fetchFeaturedArtwork = async () => {
    try {
      setIsLoading(true)
      const response = await dashboardAPI.getFeedData('featured-artwork')
      if (response) {
        if (Array.isArray(response.cards)) {
          setFeaturedArtworkList(response.cards)
        }
        if (response.updatedBy) {
          setArtist(response.updatedBy.username)
        }
      }
    } catch (error) {
      console.error('Error fetching shop physical data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchFeaturedArtwork()
  }, [])

  const handleSeeAll = () => {
    router.push('/explore')
  }

  const handleCardClick = item => {
    if (item.id) {
      router.push(`${item.targetUrl}`)
    }
  }

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <section className={styles.container}>
      <div className="w-full g-container justify-between lg:flex hidden">
        <div className={styles.headerContent}>
          <div className={styles.title}>Featured Artwork</div>
          <p className={styles.description}>Curated by {artist}</p>
          <button className={styles.seeAllButton} onClick={handleSeeAll}>
            SEE ALL &gt;&gt;
          </button>
        </div>
        <div className="flex items-end gap-5">
          <HomePrevButton onClick={() => handlePrev()} />

          <HomeNextButton onClick={() => handleNext()} />
        </div>
      </div>

      <div className="w-full g-container justify-between lg:hidden flex">
        <div className={styles.headerContent}>
          <div className={styles.title}>Featured Artwork</div>
          <p className={styles.description}>Curated by {artist}</p>
        </div>
      </div>

      <div className="w-full lg:block hidden mt-[45px]">
        <Swiper
          navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl'}
          slidesPerView={
            viewport === 'xs' ? 1.41 : viewport === 'sm' ? 2 : viewport === 'md' ? 3 : viewport === 'lg' ? 4 : 4
          }
          spaceBetween={viewport === 'xs' ? 20 : viewport === 'sm' ? 11 : 11}
          className="heroMobileNavigationSwiper"
          onSwiper={swiper => {
            swiperRef.current = swiper
          }}
        >
          {featuredArtworkList.map((item, index) => (
            <SwiperSlide key={index}>
              <FeaturedArtworkCard data={item} onClick={item => handleCardClick(item)} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={`w-full lg:hidden flex gap-[15px] overflow-x-auto mt-[25px] px-[16px] ${styles.hideScrollbar}`}>
        {featuredArtworkList.map((item, index) => (
          <div key={index} className="max-w-[300px] min-w-[300px] h-[438px] overflow-hidden">
            <FeaturedArtworkCard data={item} onClick={item => handleCardClick(item)} />
          </div>
        ))}
      </div>

      <div className="w-full g-container flex lg:hidden justify-center mt-[25px] px-[20px]">
        <button className={styles.seeMore} onClick={handleSeeAll}>
          See More
        </button>
      </div>
    </section>
  )
}

export default FeaturedArtworkSection
